// src/pages/VideoBGRemover.js
import React from 'react';
import MiniToolPageLayout from '../components/MiniToolPageLayout';
import VideoBgTool from '../components/VideoBgTool';
import { IoFilmOutline } from 'react-icons/io5';

// --- Page-Specific Data ---
const pageData = {
  seo: {
    title: "Free AI Video Background Remover | Oolook Tools",
    description: "Remove the background from any video online for free. Oolook's AI tool requires no green screen and delivers clean, professional results in seconds.",
    image: 'https://oolook.in/og/video-bg-remover.png',
    schemas: [{
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "AI Video Background Remover",
      "operatingSystem": "All",
      "applicationCategory": "VideoEditing",
      "description": "Oolook’s Video Background Remover lets you automatically remove the background from any video using artificial intelligence.",
      "url": "https://oolook.in/video-bg-remover",
      "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    }]
  },
  hero: {
    icon: IoFilmOutline,
    title: "Video Background Remover",
    subtitle: "Create professional, transparent-background videos without a green screen. Upload your clip and let our AI do the heavy lifting."
  },
  guide: {
    title: "How It Works",
    subtitle: "Studio-quality video cutouts in three simple steps.",
    steps: [
      { title: "1. Upload Your Video", description: "Drag and drop your video file onto the canvas. We support MP4, MOV, and WEBM formats up to 100MB." },
      { title: "2. AI Processing", description: "Our intelligent AI analyzes your video frame-by-frame to precisely separate the subject from the background." },
      { title: "3. Download Your MP4", description: "Your new video with a transparent background is ready. Download your high-quality, ready-to-use clip." }
    ]
  }
};

const VideoBGRemover = () => {
  return (
    <MiniToolPageLayout seo={pageData.seo} hero={pageData.hero} guide={pageData.guide}>
      <VideoBgTool />
    </MiniToolPageLayout>
  );
};

export default VideoBGRemover;